export default "__VITE_ASSET__B5Mu$otb__"